import { z } from 'zod';
import { esquemaId, esquemaMotivo } from './comunes.js';
/**
 * Documentos compartidos con la paciente (F4.9, plan maestro §8.2 «Mis
 * documentos»).
 *
 * Que un documento exista y este firmado no lo pone en el portal: alguien del
 * equipo lo COMPARTE, y puede retirarlo con motivo. Las dos cosas quedan en el
 * historial. El documento firmado no se toca: la comparticion vive aparte.
 * Una receta cancelada deja de verse aunque siga compartida.
 */
export const TIPOS_DE_DOCUMENTO_COMPARTIBLE = ['receta', 'nota'];
export const ESTADOS_DE_COMPARTICION = ['compartido', 'retirado'];
export const esquemaCompartirDocumento = z
    .object({ tipo: z.enum(TIPOS_DE_DOCUMENTO_COMPARTIBLE), documentoId: esquemaId })
    .strict();
export const esquemaRetirarComparticion = z.object({ motivo: esquemaMotivo }).strict();
//# sourceMappingURL=documentosCompartidos.js.map